// not-found.component.ts
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  template: `
    <div class="not-found-container">
      <div class="content">
        <h1>404</h1>
        <div class="message">
          <h2>Seite nicht gefunden</h2>
          <p>
            Ups! Diese Seite existiert leider nicht. Da hat sich der Entwickler
            bestimmt wieder vertippt.
          </p>
        </div>
        <button (click)="goHome()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
          <span>Zur Startseite</span>
        </button>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .not-found-container {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2rem;
      }

      .content {
        text-align: center;
      }

      h1 {
        font-size: 4rem;
        margin-bottom: 1rem;
      }

      .message {
        margin-bottom: 1rem;
      }

      button {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.5rem 1rem;
        border: none;
        background: var(--theme-primary);
        color: white;
        cursor: pointer;
        margin: 0 auto;
      }

      svg {
        width: 20px;
        height: 20px;
      }
    `,
  ],
})
export class NotFoundComponent {
  router = inject(Router);

  goHome(): void {
    this.router.navigate(['/']);
  }
}
